export const auth = {
  login: 'Bejelentkezés',
  loginSubtitle: 'Jelentkezz be az ügyfeleid kezeléséhez',
  register: 'Regisztráció',
  registerSubtitle: 'Hozz létre egy új fiókot',
  resetPassword: 'Jelszó visszaállítása',
  resetSubtitle: 'Add meg az e-mail címed a jelszó visszaállításához',
  email: 'E-mail cím',
  password: 'Jelszó',
  displayName: 'Teljes név',
  forgotPassword: 'Elfelejtetted a jelszavad?',
  noAccount: 'Még nincs fiókod?',
  hasAccount: 'Már van fiókod?',
  or: 'vagy',
  signInWithGoogle: 'Bejelentkezés Google-lal',
  signUpWithGoogle: 'Regisztráció Google-lal',
  acceptTerms: 'Elfogadom a',
  termsOfService: 'Felhasználási feltételeket',
  and: 'és az',
  privacyPolicy: 'Adatvédelmi szabályzatot',
  signUp: 'Regisztráció',
  backToLogin: 'Vissza a bejelentkezéshez',
  sendResetLink: 'Visszaállítási link küldése',
  resetEmailSent: 'Jelszó visszaállítási e-mail elküldve',
  invalidEmail: 'Érvénytelen e-mail cím',
  invalidPassword: 'A jelszónak legalább 6 karakter hosszúnak kell lennie',
  requiredField: 'Ez a mező kötelező',
  processing: 'Feldolgozás...',
  passwordTooShort: 'A jelszó legalább 6 karakter hosszú legyen',
  passwordRequired: 'A jelszó megadása kötelező',
  emailRequired: 'Az e-mail cím megadása kötelező',
  displayNameRequired: 'A név megadása kötelező',
  invalidCredentials: 'Hibás e-mail cím vagy jelszó.',
  attemptsRemaining: 'Még {{count}} próbálkozása maradt.',
  accountLocked: 'Túl sok sikertelen próbálkozás. Próbálja újra {{minutes}} perc múlva.',
  accountLockedSeconds: 'Túl sok sikertelen próbálkozás. Próbálja újra {{seconds}} másodperc múlva.',
  accountLockedContactAdmin: 'Túl sok sikertelen próbálkozás. Vegye fel a kapcsolatot a rendszergazdával.',
  mfaTitle: 'Kétfaktoros hitelesítés',
  mfaSubtitle: 'Add meg az Authenticator alkalmazásodból a 6 számjegyű kódot',
  verificationCode: 'Ellenőrző kód',
  codeChangesEvery: 'A kód 30 másodpercenként változik',
  verifying: 'Ellenőrzés...',
  cancel: 'Mégse',
  mfaTip: 'Nyisd meg az Authenticator alkalmazást a telefonodon és add meg az aktuális 6 számjegyű kódot.',
  mfaTipLabel: 'Tipp:',
  mfaCodeLengthError: 'A kódnak 6 számjegyűnek kell lennie',
  mfaSmsNotSupported: 'SMS-alapú MFA nem támogatott ebben a verzióban',
  mfaUnknownFactor: 'Ismeretlen MFA típus',
  mfaInvalidCode: 'Érvénytelen kód. Próbáld újra!',
  mfaCodeExpired: 'A kód lejárt. Kérj újat!',
  mfaVerificationError: 'Hiba az ellenőrzés során: '
};
